import {lazy} from 'react';

const CalendarDetail = lazy(() => import('./CalendarDetail'));

export default CalendarDetail;
